<template>
    <v-content>
        <v-row class="subtitle is-3 login__title">
            <v-col>
                {{ $t("password_restoration") }}
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                v-show="state == 'start'"
                class="text-center"
                cols="12"
                xl="8"
                lg="8"
                md="8"
                sm="8"
            >
                <v-text-field
                    :label="$t('phone_number_when_you_register')"
                    outlined
                    v-model="phone"
                    v-validate="'required'"
                    :error-messages="errors.collect('phone')"
                    data-vv-name="phone_number"
                    required
                    v-mask="$t('mask.phone')"
                >
                </v-text-field>
                <v-btn large color="primary" @click="next()">
                    {{ $t("next") }}<v-icon medium color="white">mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
            <v-col
                v-show="state == 'email'"
                class="text-center"
                cols="12"
                xl="8"
                lg="8"
                md="8"
                sm="8"
            >
                <div style="margin-bottom: 5px;">
                    <span v-html="$t('we_sent_mail_to_you', { email: email })"></span>
                </div>
                <v-text-field
                    :label="$t('code_from_mail')"
                    outlined
                    v-model="code"
                    v-validate="'required|digits:6'"
                    :error-messages="errors.collect('code')"
                    data-vv-name="code"
                    v-mask="'######'"
                    required
                >
                </v-text-field>
                <v-btn large color="primary" @click="receiveCodeEmail()">
                    {{ $t("restore_password")
                    }}<v-icon medium color="white">mdi-arrow-right</v-icon>
                </v-btn>
                <!-- <v-btn text @click="sendSms()">
                    {{$t('send_SMS_to_phone')}}
                </v-btn> -->
            </v-col>
            <v-col
                v-show="state == 'mobile'"
                class="text-center"
                cols="12"
                xl="8"
                lg="8"
                md="8"
                sm="8"
            >
                <div style="margin-bottom: 5px;">
                    <span
                        v-html="$t('SMS_was_send_to_phone', { phone: phone })"
                        style="margin-bottom: 5px;"
                    ></span>
                </div>
                <v-text-field
                    :label="$t('code_from_sms')"
                    outlined
                    v-model="code"
                    v-validate="'required|digits:6'"
                    :error-messages="errors.collect('code')"
                    data-vv-name="code"
                    v-mask="'######'"
                    required
                >
                </v-text-field>
                <v-btn large color="primary" @click="receiveCodeSms()">
                    {{ $t("restore_password")
                    }}<v-icon medium color="white">mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <overlay-loader :show="isLoading"></overlay-loader>
        <ChangePasswordModal :email="email" :phone="phone"></ChangePasswordModal>
    </v-content>
</template>

<script>
import ChangePasswordModal from "@/app/client/profile/shared/modals/newPassword";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "ForgotPassword",
    components: {
        OverlayLoader,
        ChangePasswordModal,
    },
    data() {
        return {
            state: "start",
            codeSended: false,
            code: "",
            email: "",
            phone: "",
        };
    },
    methods: {
        sendEmail() {
            this.$store
                .dispatch("SEND_CODE", this.email)
                .then(() => {
                    this.codeSended = true;
                })
                .catch((data) => {
                    this.$toast.error(data.response.data.message);
                });
        },
        sendSms() {
            this.state = "mobile";
            this.$store
                .dispatch("SEND_SMS", this.phone.replace(/\D+/g, ""))
                .then(() => {
                    this.codeSended = true;
                })
                .catch((data) => {
                    this.$toast.error(data.response.data.message);
                });
        },
        receiveCodeEmail() {
            if (this.codeValid) {
                const params = {
                    email: this.email,
                    code: this.code,
                };
                this.$store
                    .dispatch("RECEIVE_CODE_EMAIL", params)
                    .then(() => {
                        this.$store.dispatch("CHANGE_NEW_PASSWORD_MODAL", true);
                    })
                    .catch((data) => {
                        let msg = "";
                        if (data.response.data.message == "users not found") {
                            msg = this.$t("errors.user_not_found");
                        } else if (data.response.data.message == "Wrong code") {
                            msg = this.$t("errors.wrong_code");
                        } else {
                            msg = this.$t("errors.server_error");
                        }
                        this.$toast.error(msg);
                    });
            } else {
                this.$toast.error(this.$t("errors.wrong_code"));
            }
        },
        receiveCodeSms() {
            if (this.codeValid) {
                const params = {
                    phone: this.phone.replace(/\D+/g, ""),
                    code: this.code,
                };
                this.$store
                    .dispatch("RECEIVE_CODE_SMS", params)
                    .then(() => {
                        this.$store.dispatch("CHANGE_NEW_PASSWORD_MODAL", true);
                    })
                    .catch((data) => {
                        if (data.response.data.message == "users not found") {
                            msg = this.$t("errors.user_not_found");
                        } else if (data.response.data.message == "Wrong code") {
                            msg = this.$t("errors.wrong_code");
                        } else {
                            msg = this.$t("errors.server_error");
                        }
                        toas.$toast.error(msg);
                    });
            } else {
                this.$toast.error(this.$t("errors.wrong_code"));
            }
        },
        next() {
            const params = {
                phone: this.phone.replace(/\D+/g, ""),
            };
            this.$store
                .dispatch("GET_USER_EMAIL", params)
                .then((data) => {
                    if (
                        data.data.is_email_confirm == false &&
                        data.data.is_phone_confirm == false
                    ) {
                        this.$toast.error(this.$t("errors.user_not_registered"));
                    } else if (
                        data.data.is_email_confirm == false &&
                        data.data.is_phone_confirm == true
                    ) {
                        // отправляем сразу на мобилку
                        this.state = "mobile";
                        this.sendSms();
                    } else if (data.data.is_email_confirm == true) {
                        // отправляем сразу на почту, даем возможность отправить на мобилку
                        this.state = "email";
                        this.email = data.data.email;
                        this.sendEmail();
                    }
                })
                .catch((data) => {
                    let msg = "";
                    if (data.response.data.message == "users not found") {
                        msg = this.$t("errors.user_not_found");
                    } else {
                        msg = this.$t("errors.server_error");
                    }
                    this.$toast.error(msg);
                });
        },
    },
    computed: {
        phoneValid() {
            return this.fields.phone && this.fields.phone.valid;
        },
        codeValid() {
            return this.fields.code && this.fields.code.valid;
        },
        isLoading() {
            return this.$store.getters.AUTH_IS_LOADING;
        },
        formValid() {
            this.$validator.validateAll(); // способ подсветить все поля с момента загрузки страницы
            // loop over all contents of the fields object and check if they exist and valid.
            return Object.keys(this.fields).every(
                (field) => this.fields[field] && this.fields[field].valid
            );
        },
    },
};
</script>

<style></style>
